// src/pages/DailyPlanner.jsx
import React, { useEffect, useState } from "react";
import CollectionPage from "./CollectionPage";
import { getDailyPlanners, PRODUCTS_PER_PAGE } from "../data/dailyPlanners";
import SEOHead from "../components/common/SEOHead";
import ProductListSchema from "../components/common/ProductListSchema";
import FAQSchema from "../components/common/FAQSchema";

const PAGE_URL = "https://aishcraft.com/dailyplanners";

const dailyPlannerFAQs = [
  {
    question: "Are these daily planners dated or undated?",
    answer: "Our daily planners are undated, so you can start using them any day of the year.",
  },
  {
    question: "Can I personalize the cover with my name?",
    answer: "Yes, every planner can be customized with your name, initials, or a custom message on the cover.",
  },
  {
    question: "How long does delivery take?",
    answer: "Personalized planners are made to order and typically ship within 6 working days across India.",
  },
];

export default function DailyPlanner() {
  const [products, setProducts] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getDailyPlanners()
      .then(setProducts)
      .catch((err) => setError(err.message || "Failed to load products"));
  }, []);

  const seo = (
    <SEOHead
      title="Daily Planners | Personalized Undated Planners"
      description="Shop 300+ beautifully designed personalized daily planners. Undated, customizable, premium quality — perfect for seamless planning."
      url={PAGE_URL}
      breadcrumbs={[
        { name: "Home", item: "https://aishcraft.com/" },
        { name: "Daily Planners", item: PAGE_URL },
      ]}
    />
  );

  if (error) {
    return (
      <>
        {seo}
        <div className="min-h-screen flex items-center justify-center text-red-600">{error}</div>
      </>
    );
  }

  if (!products) {
    return (
      <>
        {seo}
        <div className="min-h-screen flex items-center justify-center text-gray-500">Loading...</div>
      </>
    );
  }

  const config = {
    products,
    productsPerPage: PRODUCTS_PER_PAGE,
    basePath: "/dailyplanners",
    announcement: {
      headline: "Get 20% Off the new 2026 Planners!",
      subtext: "300+ designs to personalise • No code required",
    },
    hero: {
      title: "Diaries",
      subtitle: "Pages for seamless planning",
      featuredIn: ["PREMIUM QUALITY", "TRUSTED CRAFTSMANSHIP", "PAN INDIA DELIVERY"],
      quote: "This planner makes me so organised and looks so pretty on my desk! My fav undated planner yet!",
      quoteLink: "#",
      rating: "4.7",
      ratingCount: "1000+",
    },
  };

  return (
    <>
      {seo}
      <ProductListSchema products={products} pageUrl={PAGE_URL} />
      <FAQSchema faqs={dailyPlannerFAQs} />
      <CollectionPage config={config} />
    </>
  );
}